import './ViewProjectInProgress.css';

import React, { Component, useState, useEffect} from 'react';
import Base64	from 'Base64';
import { gapi } from 'gapi-script';
import Switch	from "react-switch";
import Collapse from 'react-bootstrap/Collapse';
import HorizontalAvatarList from 'components/HorizontalAvatarList';
import {Input, Modal, ModalBody, ModalFooter, ModalHeader, Col, Row} from 'reactstrap';

import Task		from "./model/Tasks/Task";
import Page		from 'components/Page';
import ComboBox from './component/ComboBox';
import SearchInput from 'components/SearchInput';
import { Cookies } from 'react-cookie';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import DataAdapter from './adapter/DataAdapter';
import ViewTask from './model/Tasks/ViewTask';
import Project from './model/Projects/Project';
import {Filter, Grid} from './dashboard/DashboardComponents';

import {
  FloatingMenu,
  MainButton,
  ChildButton,
} from 'react-floating-button-menu';
 
const _COL_ID_	=	'prj_id';
const _COL_		=	'prj_id';

 
const cookie =new Cookies();


var __PERSON__, __PERSON_ROLE__, __STATUS__,__COLUMNS__;
var __STATUS__		=	"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25";

function allowDrop(e) {
	e.preventDefault();
}

class ViewProjectInProgress extends React.Component {
	notificationSystem = React.createRef();

	constructor(props){
		super(props);
		__PERSON__ = cookie.get("v-person-id");
		__PERSON_ROLE__ = cookie.get("v-person-role");
        if(props.match){
            __STATUS__ = this.props.match.params.status;
        }else{
            __STATUS__ = this.props.status;
        }
		__STATUS__ = (__STATUS__==null?"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25": __STATUS__);

		this.state = {
			projects			: [], 
			dataset				: [], 
			columns				: __STATUS__.split(','), 
			person				: __PERSON__,  
			status				: __STATUS__, 
			actionModal			: false, 
			loadingStatusForm	: false, 
			statusModal			: false, 
			project_id			:0, 
			project				: [], 
			task_id				:0, 
			task				:[], 
			hasDrawings			:false,
			hasPermit			:false,
			hasModel			:false,
			search				:'',
			isCompact			: true,
			};
		this.loadData(__STATUS__, __PERSON__);


	}

	loadData = (_status, _person) => {
		var query = "SELECT sum(if(ptd.task_type=37,1,0)) AS `note_count`,group_concat(if(ptd.task_type=37,ptd.note,''),'---') AS `note_list`, sum(if(ptd.task_type=98,1,0)) AS `clock_count`,group_concat(if(ptd.task_type=98,ptd.Clock_in,'')) AS `clock_list`,pt.pt_id, pt.parent, pt.task, pt.task_description, pt.sender_id, pt.receiver_id, pt.item_no, pt.task_no, p.name AS `receiver` , pt.expected_end_date, DATE_FORMAT(CONVERT_TZ(pt.start_date,@@session.time_zone,'-04:00'),'%d %M %H:%i') AS `start_date`, pt.start_date AS `start_date_full`, DATE_FORMAT(CONVERT_TZ(pt.end_date,@@session.time_zone,'-04:00'),'%d %M %H:%i') AS `end_date`, pt.end_date AS `end_date_full`, pt.task_status AS `task_status_id`, tyyyyy.rb_type_desc as `task_status`, pt.task_type AS `task_type_id`, tyyyy.rb_type_desc AS `task_type`, pt.percent_done, pt.real_hours, pt.estimate_hours , tyyy.rb_type_desc as category_desc, prj.prj_category_1 as category, prj.prj_department,de.rb_type_desc AS department,prj.prj_id, prj.prj_code, prj.prj_title, prj.prj_desc, prj.prj_address, prj.prj_city, ty.rb_type_desc AS prj_status, prj_status as prj_status_id, prj.prj_budget, prj.prj_budget_highest, prj.prj_budget_lowest, DATE_FORMAT(CONVERT_TZ(prj.prj_posted_date,@@session.time_zone,'-04:00'),'%d %M') AS prj_posted_date, prj.prj_posted_date as `prj_posted_date_full`, prj.refered_by_person_id, prj.refered_by_prj_id, year(prj_posted_date) as prj_year, prj.has_drawings, prj.has_permit,prj.has_model, prj.prj_folder_id, prj.prj_category_1, prj.prj_category_2, prj.prj_category_3, pr.* FROM rb_projects prj LEFT JOIN rb_project_tasks pt ON pt.prj_id = prj.prj_id LEFT JOIN rb_project_task_details ptd ON ptd.pt_id = pt.pt_id LEFT JOIN rb_types ty ON ty.rb_type_no = prj.prj_status AND ty.rb_type = 'prj_status' LEFT JOIN rb_types de ON de.rb_type_no=prj.prj_department AND de.rb_type='prj_department' LEFT JOIN rb_person pr ON pr.person_id = prj.client_id LEFT JOIN rb_types tyyy ON (tyyy.rb_type_no = prj.prj_category_1 AND tyyy.rb_type = 'person_trade') LEFT JOIN rb_types tyyyy ON (tyyyy.rb_type_no = pt.task_type AND tyyyy.rb_type = 'task_type') LEFT JOIN rb_types tyyyyy ON (tyyyyy.rb_type_no = pt.task_status AND tyyyyy.rb_type = 'task_status') LEFT JOIN rb_person p ON p.person_id = pt.receiver_id LEFT JOIN rb_types tyyyyyy ON (tyyyyyy.rb_type_no = ptd.task_type AND tyyyyyy.rb_type='task_type') WHERE prj.prj_status IN (9) AND pt.task_status IN (9) AND prj.prj_department=12 AND " + (__PERSON_ROLE__*1==0 || __PERSON_ROLE__*1==1 || __PERSON_ROLE__*1==10? "true":"pt.receiver_id=" + __PERSON__) + " GROUP BY pt.pt_id ORDER BY ty.rb_type_no, prj.prj_posted_date desc, pt.sort_id;";
		var dataAdapter =new DataAdapter(query);
			dataAdapter.getRecords()
			.then(response=>{
				this.setState({projects : response, dataset : response});
			})

		dataAdapter =new DataAdapter("SELECT * FROM rb_types WHERE rb_type ='" + _COL_ + "';");
			dataAdapter.getRecords()
			.then(response=>{
				this.setState({prj_status_array : response});
			})

	}

    componentDidUpdate(prevProps, prevState, snapshot){
        if (this.props.status != prevProps.status) {
			this.setState({person : prevProps.person,  status : prevProps.status});
			this.loadData(prevProps.status, prevProps.person);
		}
    }
	
	onClearFilter		=	(e) =>{
		e.persist();
		this.setState({projects	:	this.state.dataset})

	}
	onFilterChange 		=	(e) =>{
		e.persist();
		var projects = this.state.dataset;
		var valueField	=	e.target.attributes[0].value;
		this.setState({projects	:	projects.filter(p=>p[valueField]==e.target.value || e.target.value==-1)})
		//this.setState({dataset	:	projects.filter(p=>p[valueField]==e.target.value || e.target.value==-1)})
	}
	onFromDateChange	=	(e) =>{
		e.persist();
		var projects = this.state.projects;
		var valueField	=	e.target.attributes[0].value;
		this.setState({projects	:	projects.filter(p=>p["start_date"]>=e.target.value || p["end_date"]>=e.target.value )})
		//this.setState({dataset	:	projects.filter(p=>p[valueField]>=e.target.value )})
	}
	onToDateChange		=	(e) =>{
		e.persist();
		var projects = this.state.projects;
		var valueField	=	e.target.attributes[0].value;
		this.setState({projects	:	projects.filter(p=>p["start_date"]<=e.target.value || p["end_date"]<=e.target.value  )})
		//this.setState({dataset	:	projects.filter(p=>p[valueField]<=e.target.value )})
	}
	onHasDrawings		=	( ) =>{
		
		var projects = this.state.dataset;		
		if(!this.state.hasDrawings)
			this.setState({projects	:	projects.filter(p=>p["has_drawings"]*1==1)});
		else
			this.setState({projects	:	projects});
		
		this.setState({hasDrawings : !this.state.hasDrawings});
	}
	onHasPermit			=	( ) =>{
		
		var projects = this.state.dataset;		
		if(!this.state.hasPermit)
			this.setState({projects	:	projects.filter(p=>p["has_permit"]*1==1)});
		else
			this.setState({projects	:	projects});
		
		this.setState({hasPermit : !this.state.hasPermit});
	}
	onHasModel			=	( ) =>{
		
		var projects = this.state.dataset;		
		if(!this.state.hasModel)
			this.setState({projects	:	projects.filter(p=>p["has_model"]*1==1)});
		else
			this.setState({projects	:	projects});
		
		this.setState({hasModel : !this.state.hasModel});
	}
	
	render(){
		var projects = this.state.projects;
		return (
			<Page className="DashboardPage" title="In Progress Dashboard" >
					<Row>
						<Col lg={12} md={12} sm={12} xs={12}  >
							<button class="btn btn-secondary btn-sm"  onClick={(event)=>{window.location="/#/MAP"  }} >Projects Map</button>{'	'}
						</Col>
					</Row>
					<Row className="d-none" >
						<Col lg={12} md={12} sm={12} xs={12} >
							<SearchInput onChange={(e)=>{
								e.persist();
								var projects = this.state.dataset;
								var valueField	=	e.target.value;
								
								this.setState({projects	:	projects.filter(p=>p["prj_id"].includes(valueField) || (p["prj_address"]?p["prj_address"].toLowerCase().includes(valueField):false) || (p["name"]?p["name"].toLowerCase().includes(valueField):false) || (p["lastname"]?p["lastname"].toLowerCase().includes(valueField):false) || e.target.value=='')});
								}} />
						</Col>
						<Col lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Year" displayField="prj_year" valueField="prj_year" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Department" displayField="department" valueField="prj_department" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Category" displayField="category_desc" valueField="category" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Person" displayField="receiver" valueField="receiver_id" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>						
						<Col lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasDrawings();}} checked={this.state.hasDrawings} /><span>Has Drawings</span>
						</Col>
						<Col lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasPermit();}} checked={this.state.hasPermit} /><span>Has Permit</span>
						</Col>
						<Col lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasModel();}} checked={this.state.hasModel} /><span>Has Model</span>
						</Col>
						<Col lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasEstimate();}} checked={this.state.hasEstimate}  /><span>Has Estimate</span>
						</Col>
						<Col lg={6} md={6} sm={6} xs={12} >
							<Input text="start_date" type={'date'} onChange={this.onFromDateChange} />
						</Col>
						<Col lg={6} md={6} sm={6} xs={12} >
							<Input text="end_date" type={'date'} onChange={this.onToDateChange} />
						</Col>
				</Row>
				<Row>					
					<Col lg={12} md={12} sm={12} xs={12} >
						<Grid colId={_COL_ID_} col={_COL_} isCompact={this.isCompact} isCollapse={this.state.isCollapse} clockIn={(event, _projects)=>this.onClockInHandler(event, _projects)} clockOut={(event, _projects)=>this.onClockOutHandler(event, _projects)} callback={this.callback} columns={this.state.columns} projects={this.state.projects} onActionHanlder={(e)=>{this.onActionHanlder(e)}} onStatusHanlder={(e)=>{this.onStatusHanlder(e)}} drag={(e)=>{this.drag(e)}} drop={(e)=>{this.drop(e)}}  />
					</Col>
				</Row>	
				<NotificationSystem ref={this.notificationSystem} style={NOTIFICATION_SYSTEM_STYLE}/>
				{this.statusForm()}
			</Page>
				);
	}

    addNotification (_MESSAGE_) {
		const notification = this.notificationSystem.current;
		notification.addNotification({
		  message: _MESSAGE_,
		  level: 'success'
		});
	};	

	onStatusHanlder				=	(e)=>{
		e.persist();
		if(this.state.statusModal){
			this.setState({statusModal: false});
		}else{
			this.setState({
				statusModal				:	true,
				loadingStatusForm		:	true,
				prj_id				:	e.target.attributes[0].value,
				prj_status			:	e.target.attributes[1].value,
				prj_department		:	e.target.attributes[2].value,
			});
		}
	}
	onActionHanlder				=	(e)=>{
		e.persist();
		
		if(this.state.actionModal){
			this.setState({actionModal: false});
		}else{
			this.setState({
				task				:	this.state.projects.filter(p=>p.pt_id*1 == e.target.attributes["data-task-id"].nodeValue*1)[0], 
				actionModal			:	true,
				task_id				:	e.target.attributes["data-task-id"].nodeValue,
				project_id			:	e.target.attributes["data-project-id"].nodeValue,
				});
		}
	}
	onProjectStatusChnageHandler=	(e)=>{
		var _projects	=	this.state.projects;
		_projects.forEach((project, index) => {
			if(project.prj_id == this.state.prj_id){
				project.prj_status_id	=	e.target.value;
				project.prj_status 		=	this.state.prj_status_array.find(s=>s.rb_type_no*1 == e.target.value*1).rb_type_desc;							
			}
		  _projects[index] = project;
		});
		//var _index		=	_projects.findIndex(p=>p.prj_id == this.state.prj_id);

		this.runQuery("UPDATE rb_projects SET prj_status = '" + e.target.value + "' WHERE prj_id=" + this.state.prj_id, 'Project Status Updated!');
		this.setState({ projects : _projects, statusModal:false});

	}
	onPreStatus					=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	_projects[_index].prj_status_id*1 -1;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;

		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_projects SET prj_status = prj_status-1 WHERE prj_id=" + this.state.prj_id, "Project Status changed");

		this.setState({ projects : _projects, project : _project});
	}
	onNxtStatus					=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	_projects[_index].prj_status_id*1 +1;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;

		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_projects SET prj_status = prj_status+1 WHERE prj_id=" + this.state.prj_id, "Project Status changed");

		this.setState({ projects : _projects, project : _project});
	}
	onHoldHandler				=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	12;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;
		
		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_project_tasks SET task_status = 12 WHERE prj_id=" + this.state.prj_id, "Task has been holded");
		this.runQuery("UPDATE rb_projects SET prj_status = 12 WHERE prj_id=" + this.state.prj_id, "Project has been holded");

		this.setState({ projects : _projects, project : _project, modal : false});
	}
	onCloseHandler				=	(e)=>{
		e.persist();
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	_projects[_index].prj_status_id*1 + 13;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;
		
		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_project_tasks SET task_status = 10 WHERE prj_id=" + this.state.prj_id, "Task has been closed");
		this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.prj_id, "Project has been closed");

		this.setState({ projects : _projects, project : _project, modal : false});
	}
	onChangeTaskStatus			=	(e)=>{
		e.persist();
		var task =new Task();
		task.changeStatus(e.target.attributes["data-id"].nodeValue, e.target.attributes["data-status-id"].nodeValue);
		//props.onChangeTaskStatus(e);
		this.addNotification("Task status changed", "info");
	}
	onClockInHandler=(e, _project)=>{
		e.persist();

		var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
		var	sql ="INSERT INTO rb_project_task_details ( pt_id, prj_id, task_status, task_type, sender_id, receiver_id, Clock_in ) values " +
				"(" + e.target.attributes["data-task-id"].nodeValue + ", " + e.target.attributes["data-project-id"].nodeValue + ", 9 , 98 , " + cookie.get('v-person-id') + "," + cookie.get('v-person-id') + ", '" + _UTC_ + "')" ;

		this.runQuery( sql, "Clocked In", "success");
		this.runQuery("UPDATE rb_project_tasks SET task_status = 9 WHERE pt_id=" + e.target.attributes["data-task-id"].nodeValue, "Task status has been updated", "info");

		// this.setState({actionModal: true});

		this.setState({ projects : _project});

	}
	onClockOutHandler=(e, _project)=>{
		e.persist();
		var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
		var sql	=	"UPDATE rb_project_task_details SET percent_done=100,note='', task_status = 10, Clock_out = '" + _UTC_ + "', real_hours = TIMESTAMPDIFF(MINUTE, Clock_in, '" + _UTC_ + "') " +
		"WHERE task_status=9 AND pt_id=" + e.target.attributes["data-task-id"].nodeValue + " AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + " ORDER BY ptd_id DESC limit 1;";
		this.runQuery(sql, "Clock Out", "error");		

		 sql	=	"UPDATE rb_project_tasks SET real_hours = (" +
					"SELECT sum(TIMESTAMPDIFF(MINUTE, Clock_in, Clock_out)) FROM `rb_project_task_details`" +
					"WHERE pt_id = " + e.target.attributes["data-task-id"].nodeValue + " AND task_status=10 AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + "), percent_done = (select sum(percent_done) from rb_project_task_details WHERE pt_id = " + e.target.attributes["data-task-id"].nodeValue + " AND task_status=10 AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + ") where pt_id = " + e.target.attributes["data-task-id"].nodeValue  + ";";

		this.runQuery(sql, "Real hours calculated", "info");		
		// this.setState({actionModal: false});
		var _index	= _project.findIndex(p=>p.pt_id == e.target.attributes['data-task-id'].nodeValue);
		//_project[_index].percent_done	 = 100;
		this.setState({ projects : _project});

	}

	statusForm					= 	() => {
		if(this.state.loadingStatusForm){
			var query = "SELECT * FROM rb_projects WHERE prj_id=" + this.state.prj_id;
			var dataAdapter =new DataAdapter(query);
				dataAdapter.getRecords()
				.then(response=>{
					this.setState({project : response[0], loadingStatusForm : false});
				})	
		}
		
		return (
			<>
				<Modal isOpen={this.state.statusModal} >
					<ModalHeader>
						<Row>
							<Col>
								<b>#{this.state.prj_id}</b> <small>{this.state.project.prj_title}</small>
							</Col>
							<Col>						
								<button type="button" className="btn btn-primary btn-sm float-right ml-1 mr-1" onClick={(event)=>{this.setState({statusModal : false})}} >X</button>{' '}
							</Col>
						</Row>
					</ModalHeader>
					<ModalBody>
						<b>Status : </b>
						<ComboBox defaultValue={this.state.project.prj_status}  onChange={this.onProjectStatusChnageHandler}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="prj_status" order="rb_type_no" />
					</ModalBody>
					{/*
					<ModalBody>
						<button id={'pre'} type="button" className="btn btn-outline-secondary btn-sm" onClick={(event) => { this.onPreStatus(event) }} >Pre Status</button>{'	'}
						<button id={'nxt'} type="button" className="btn btn-outline-secondary btn-sm" onClick={(event) => { this.onNxtStatus(event) }} >Next Status</button>{'	'}
						<button type="button" className="btn btn-outline-info btn-sm" onClick={(event) => { this.onHoldHandler(event) }} >Hold/Stop the Job</button>{'	'}
						<button type="button" className="btn btn-outline-danger btn-sm" onClick={(event) => { this.onCloseHandler(event) }} >Close the Job</button>{'	'}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={(e)=>{this.setState({statusModal:false})}} >Close</Button>{' '}
					</ModalFooter>
					*/}
				</Modal>
			</>
		);
	}
	runQuery					=	(query, message)=>{
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = {method: 'POST',headers: {'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')},body : formData};
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/' , requestOptions)
			.then(response => {
				return Promise.all([response.json(),response])
			})
			.then(([responseData,response]) => {
				this.addNotification(message);
					
			})
			.catch(error => {
				console.error('Error:', error);
			})		
	}
	drag						=	(e) => {
		e.persist();
		if(this.state.projects){
			e.dataTransfer.setData("text", e.target.id);
		}
	}
	drop						=	(e) => {
		e.persist();
		if(e.target.attributes['status']){
			var _prj_id = e.dataTransfer.getData("text");
			var _projects	= this.state.projects;
			var _index	= _projects.findIndex(p=>p.prj_id == _prj_id);
			_projects[_index].prj_status = e.target.attributes['status'].nodeValue;
			_projects[_index].prj_status_id = e.target.attributes['status-id'].nodeValue;
			this.setState({ projects : _projects});
			this.runQuery("UPDATE rb_projects SET prj_status = " + e.target.attributes['status-id'].nodeValue + " WHERE prj_id=" + _prj_id, "Project status has been updated");
		}
	  }
	callback					=   (obj)	=>{
		var _projects	= this.state.projects;
		if(obj.callbackType == 'note'){
		}
		if(obj.callbackType == 'assign'){
				var _index	= _projects.findIndex(p=>p.pt_id == obj.response[0].pt_id);
				if(_index!=-1){
					_projects[_index].task_type = obj.response[0].task_type_desc;
					_projects[_index].task_status_id = obj.response[0].task_status;
					_projects[_index].task_status = obj.response[0].task_status_desc;
				}else{
					var _index	= _projects.findIndex(p=>p.prj_id == obj.response[0].prj_id);
					var __projects	=	JSON.parse(JSON.stringify(_projects));
					var newProject	=	__projects[_index];	
					newProject.pt_id			=	obj.response[0].pt_id;
					newProject.task_status_id	=	obj.response[0].task_status_id;
					newProject.task_status		=	obj.response[0].task_status;
					newProject.task_type_id		=	obj.response[0].task_type_id;
					newProject.task_type		=	obj.response[0].task_type;
					newProject.task				=	obj.response[0].task;
					newProject.task_description	=	obj.response[0].task_description;
					newProject.sender_id		=	obj.response[0].sender_id;
					newProject.receiver_id		=	obj.response[0].receiver_id;
					_projects.push(newProject)
				}
				this.setState({ projects : _projects});
		}
		if(obj.callbackType == 'status'){
				var _index	= _projects.findIndex(p=>p.pt_id == obj.response[0].pt_id);
				if(_index!=-1){
					_projects[_index].task_type = obj.response[0].task_type_desc;
					_projects[_index].task_status_id = obj.response[0].task_status;
					_projects[_index].task_status = obj.response[0].task_status_desc;
				}
				this.setState({ projects : _projects});
		}
		if(obj.callbackType == 'clockout'){
			var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
			var sql	=	"UPDATE rb_project_task_details SET percent_done=100,note='', task_status = 10, Clock_out = '" + _UTC_ + "', real_hours = TIMESTAMPDIFF(MINUTE, Clock_in, '" + _UTC_ + "') " +
			"WHERE task_status=9 AND pt_id=" + obj.response[0].pt_id + " AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + ";";
			this.runQuery(sql, "Clocked Out")
		}
	}
}


export default ViewProjectInProgress;

